import { Button, Grid, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React from "react";

const isSameRange = (first, second) =>
  first[0] === second[0] && first[1] === second[1];

const PresetButtons = ({ presets, value, onSelect }) => {
  const theme = useTheme();

  return (
    <Grid container spacing={1}>
      {presets.map((preset) => {
        const isActive = isSameRange(preset.value, value);

        return (
          <Grid item xs={6} key={preset.label}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              size="small"
              aria-pressed={isActive}
              onClick={() => onSelect(preset)}
              sx={{
                flexDirection: "column",
                alignItems: "flex-start",
                textTransform: "none",
                textAlign: "left",
                fontWeight: preset.description ? 500 : 400,
                fontSize: "0.8125rem",
                lineHeight: 1.3,
                borderRadius: "6px",
                py: 0.75,
                color: theme.palette.text.primary,
                borderColor: isActive
                  ? theme.palette.secondary.main
                  : theme.palette.border.main,
                bgcolor: isActive
                  ? alpha(theme.palette.secondary.main, 0.12)
                  : "transparent",
                "&:hover": {
                  borderColor: theme.palette.secondary.main,
                  bgcolor: alpha(theme.palette.secondary.main, 0.08),
                },
              }}
            >
              {preset.label}
              {preset.description && (
                <Typography
                  variant="caption"
                  component="span"
                  sx={{ color: theme.palette.lightText.main }}
                >
                  {preset.description}
                </Typography>
              )}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PresetButtons;
